export const ruleIconClassName = 'h-[40px] w-[40px] shrink-0'
